// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"Motability7SelectedCarCarousel_swiper-slide-active__A8h+Q","wrapper":"Motability7SelectedCarCarousel_wrapper__U+5zU"};